var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-infolist"},_vm._l((_vm.info),function(item,i){return _c('div',{key:i,staticClass:"ui-infolist__item"},[_c('ui-infolist-item',{attrs:{"item":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }